import { useCallback } from 'react';
import { UseQueryResult } from 'react-query';

export const useQueryRefetch = () => {
  return useCallback(async (query: UseQueryResult<any>) => {
    if (query.status !== 'idle') return;
    await query.refetch();
  }, []);
};
